export const E_INVOICE_OPERATORS = {
  MAVENTA: {
    name: 'Maventa',
    value: '003721291126,MAVENTA',
  },
  APIX_MESSAGING_OY: {
    name: 'Apix Messaging Oy',
    value: '003723327487',
  },
  BASWARE_OY: {
    name: 'Basware Oy',
    value: 'BAWCFI22',
  },
  OP_OSUUSKUNTA: {
    name: 'OP Osuuskunta',
    value: 'OKOYFIHH',
  },
  OPUSCAPITA_SOLUTIONS_OY: {
    name: 'OpusCapita Solutions Oy',
    value: 'E204503',
  },
  OPEN_TEXT_OY: {
    name: 'Open Text Oy',
    value: '003708599126',
  },
  CGI_SUOMI_OY: {
    name: 'CGI Suomi Oy',
    value: '003703575029',
  },
  PAGERO_OY: {
    name: 'Pagero Oy',
    value: '003723609900,PAGERO',
  },
  NORDEA: {
    name: 'Nordea',
    value: 'NDEAFIHH',
  },
  DANSKE_BANK_A_S_SUOMEN_SIVULIIKE: {
    name: 'Danske Bank A/S, Suomen sivuliike',
    value: 'DABAFIHH',
  },
  HANDELSBANKEN: {
    name: 'Handelsbanken',
    value: 'HANDFIHH',
  },
  NETBOX_FINLAND_OY: {
    name: 'Netbox Finland Oy',
    value: '003726044706',
  },
  OMA_SÄÄSTÖPANKKI_OYJ: {
    name: 'Oma säästöpankki Oyj',
    value: 'ITELFIHH',
  },
  POP_PANKKI: {
    name: 'POP Pankki',
    value: 'POPFFI22',
  },
  ROPO_SUOMI_OY: {
    name: 'Ropo Suomi Oy',
    value: '003714377140',
  },
  POSTNORD_STRÅLFORS_OY: {
    name: 'PostNord Strålfors Oy',
    value: '003701150617',
  },
  AKTIA_PANKKI_OYJ: {
    name: 'Aktia Pankki Oyj',
    value: 'HELSFIHH',
  },
  S_PANKKI: {
    name: 'S-Pankki',
    value: 'SBANFIHH',
  },
  TIETOEVERY_OYJ: {
    name: 'Tietoevry Oyj',
    value: '003701011385',
  },
  ÅLAND_POST_AB: {
    name: 'Åland Post Ab',
    value: '003722207029',
  },
  POSTI_MESSAGING_OY: {
    name: 'Posti Messaging Oy',
    value: 'FI28768767',
  },
  SÄÄSTÖPANKIT: {
    name: 'Säästöpankit',
    value: 'ITELFIHH',
  },
  INEXCHANGE_FACTORUM_AB: {
    name: 'InExchange Factorum AB',
    value: 'INEXCHANGE',
  },
  KOFAX_EXPERT_SYSTEMS: {
    name: 'Kofax Expert Systems',
    value: 'EXPSYS',
  },
  CREDIFLOW_AB: {
    name: 'Crediflow AB',
    value: 'CREDIFLOW',
  },

  ÅLANDSBANKEN_ABP: {
    name: 'Ålandsbanken Abp',
    value: 'AABAFI22',
  },
  COMARCH: {
    name: 'Comarch',
    value: '5909000716438',
  },
  APPER_SYSTEMS_AB: {
    name: 'Apper Systems AB',
    value: 'APPER',
  },
  LOGIQ_AS: {
    name: 'LOGIQ AS',
    value: 'LO',
  },
  ORBYT_AS: {
    name: 'Orbyt AS',
    value: 'FI28768767',
  },
  AVALARA_EUROPE_LTD: {
    name: 'Avalara Europe Ltd',
    value: '993208446351',
  },
};
